import React from 'react';

// === Assets === //
import btnVideo from '@assets/svg/video-button.svg';
import btnVideoWhite from '@assets/svg/video-button-white.svg';

// === Helpers === //
import cn from 'classnames';

// === Styles === //
import * as styles from '@components/common/VideoButton/VideoButton.module.scss';

// === Types === //
import { IVideoButton } from '@components/common/VideoButton/VideoButton.d';

const VideoButton = ({ isPlaying, setIsPlaying, className }: IVideoButton) => {
  return (
    <div
      className={cn(styles['videoButton'], className, styles[isPlaying ? 'videoButtonHide' : ''])}
    >
      <button onClick={() => setIsPlaying(true)} aria-label="video-button">
        <img
          src={btnVideoWhite}
          alt=""
          className={cn(styles['videoButtonIcon'], styles['videoButtonIconWhite'])}
          width="25px"
          height="32px"
          loading="lazy"
        />
        <img
          src={btnVideo}
          alt=""
          className={cn(styles['videoButtonIcon'], styles['videoButtonIconBlue'])}
          width="25px"
          height="32px"
          loading="lazy"
        />
      </button>
    </div>
  );
};

export default VideoButton;
